import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import { GetOrderCancelResponse, GetOrderCompleteResponse, GetPendingSkuResponse, GetWaitingShipResponse, MakeappointmentInput, MakeappointmentResponse, NewOrderResponse, GetOrderProductSkuListInput, GetOrderProductSkuListResponse, UpdateCapacityInput, UpdateCapacityResponse, SubmitNewOrderInput, SubmitNewOrderResponse, GetDataThaipostResponse, GetExportOrderThaipostResponse, GetOrderWaitingRefundResponse, UpdateApproveRequestCancelResponse, UpdateApproveRequestCancelInput, UpdateDeleteRequestCancelResponse, UpdateDeleteRequestCancelInput, MakeOrderConfirmInput, GetOrderproductskuNewOrderResponse, GetOrderproductskuNewOrderInput, CreateOrderTransactionInput, CreateOrderTransactionResponse, GetLoadNewOrderSkuInput, GetLoadNewOrderSkuResponse, OrderDistributedResponse, LotTransactionDetailInput, LotTransactionDetailResponse, OlderLotTransactionResponse, OlderLotTransactionInput, ExportOrderTransaferInput, ExportOrderTransaferResponse, OrderTransactionInput, OrderDistributedListResponse, UpdateOrderTransactionInput, UpdateOrderTransactionResponse } from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const getNewOrder = async (): Promise<NewOrderResponse> => {
  const data: AxiosResponse<NewOrderResponse> = await httpClient
    .get(API.getNewOder)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getInprocess = async (): Promise<NewOrderResponse> => {
  const data: AxiosResponse<NewOrderResponse> = await httpClient
    .get(API.getOrderInprocess)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getWaitingShip = async (): Promise<GetWaitingShipResponse> => {
  const data: AxiosResponse<GetWaitingShipResponse> = await httpClient
    .get(API.getWaitingShip)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderComplete = async (): Promise<GetOrderCompleteResponse> => {
  const data: AxiosResponse<GetOrderCompleteResponse> = await httpClient
    .get(API.getOrderComplete)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderWaitingRefund = async (): Promise<GetOrderWaitingRefundResponse> => {
  const data: AxiosResponse<GetOrderWaitingRefundResponse> = await httpClient
    .get(API.getWaitingRefund)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderCancel = async (): Promise<GetOrderCancelResponse> => {
  const data: AxiosResponse<GetOrderCancelResponse> = await httpClient
    .get(API.getOrderCancel)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getPendingsku = async (): Promise<GetPendingSkuResponse> => {
  const data: AxiosResponse<GetPendingSkuResponse> = await httpClient
    .get(API.getPendingsku)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateApproveRequestCancel = async (
  input: UpdateApproveRequestCancelInput
): Promise<UpdateApproveRequestCancelResponse> => {
  const data: AxiosResponse<UpdateApproveRequestCancelResponse> = await httpClient
    .post(API.updateApproveRequestCancel, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateDeleteRequestCancel = async (
  input: UpdateDeleteRequestCancelInput
): Promise<UpdateDeleteRequestCancelResponse> => {
  const data: AxiosResponse<UpdateDeleteRequestCancelResponse> = await httpClient
    .post(API.updateDeleteRequestCancel, input)
    .catch((error) => handleResponseError(error))
  return data.data
}
//

export const postMakeappointment = async (
  input: MakeappointmentInput
): Promise<MakeappointmentResponse> => {
  const data: AxiosResponse<MakeappointmentResponse> = await httpClient
    .post(API.makeappointment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderProductSkuList = async (
  input: GetOrderProductSkuListInput
): Promise<GetOrderProductSkuListResponse> => {
  const data: AxiosResponse<GetOrderProductSkuListResponse> = await httpClient
    .post(API.orderProductSku, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const postUpdateCapacity = async (
  input: UpdateCapacityInput
): Promise<UpdateCapacityResponse> => {
  const data: AxiosResponse<UpdateCapacityResponse> = await httpClient
    .post(API.updateCapacity, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const submitNewOrderInput = async (
  input: SubmitNewOrderInput
): Promise<SubmitNewOrderResponse> => {
  const data: AxiosResponse<SubmitNewOrderResponse> = await httpClient
    .post(API.submitNewOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getDataThaipost = async (): Promise<GetDataThaipostResponse> => {
  const data: AxiosResponse<GetDataThaipostResponse> = await httpClient
    .get(API.getOrderThaipost)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getExportDataThaipost = async (): Promise<GetExportOrderThaipostResponse> => {
  const data: AxiosResponse<GetExportOrderThaipostResponse> = await httpClient
    .get(API.getExportOrderToThaiPost)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderproductskuNewOrder = async (
  input: GetOrderproductskuNewOrderInput
): Promise<GetOrderproductskuNewOrderResponse> => {
  const data: AxiosResponse<GetOrderproductskuNewOrderResponse> = await httpClient
    .post(API.getOrderproductskuNewOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const postMakeOrderConfirm = async (
  input: MakeOrderConfirmInput
): Promise<MakeappointmentResponse> => {
  const data: AxiosResponse<MakeappointmentResponse> = await httpClient
    .post(API.makeOrderConfirm, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createOrderTransaction = async (
  input: CreateOrderTransactionInput
): Promise<CreateOrderTransactionResponse> => {
  const data: AxiosResponse<CreateOrderTransactionResponse> = await httpClient
    .post(API.createOrderTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const rollbackOrderTransaction = async (
  input: UpdateOrderTransactionInput
): Promise<UpdateOrderTransactionResponse> => {
  const data: AxiosResponse<UpdateOrderTransactionResponse> = await httpClient
    .post(API.rollbackOrderTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLoadNewOrderSku = async (
  input: GetLoadNewOrderSkuInput
): Promise<GetLoadNewOrderSkuResponse> => {
  const data: AxiosResponse<GetLoadNewOrderSkuResponse> = await httpClient
    .post(API.getLoadNewOrderSku, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderDistributed = async (
  input: string): Promise<OrderDistributedResponse> => {
  const data: AxiosResponse<OrderDistributedResponse> = await httpClient
    .get(API.getOrderDistributed + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderDistributedList = async (
  input: OrderTransactionInput
): Promise<OrderDistributedListResponse> => {
  const data: AxiosResponse<OrderDistributedListResponse> = await httpClient
    .post(API.getOrderDistributedList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLotTransactionDetail = async (
  input: LotTransactionDetailInput
): Promise<LotTransactionDetailResponse> => {
  const data: AxiosResponse<LotTransactionDetailResponse> = await httpClient
    .post(API.getDetailLotTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOlderLotTransaction = async (
  input: OlderLotTransactionInput
): Promise<OlderLotTransactionResponse> => {
  const data: AxiosResponse<OlderLotTransactionResponse> = await httpClient
    .post(API.getOlderLotTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getExportOrderTransafer = async (
  input: ExportOrderTransaferInput
): Promise<ExportOrderTransaferResponse> => {
  const data: AxiosResponse<ExportOrderTransaferResponse> = await httpClient
    .post(API.getExportOrderTransafer, input)
    .catch((error) => handleResponseError(error))
  return data.data
}
